module.exports = __webpack_public_path__ + "static/media/39.c3412640.png";